import { IFilterPayload } from '@studyportals/search-filters/server-side';
import { computed } from "vue";
import store from "@/study-search/store";
import { ApplicationStatusOptions } from "../../models/application-status/ApplicationStatusOptions";
import { PortalType } from "@studyportals/domain-client";
import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import { ProfileQuestionnairesCPIFilters } from '@studyportals/profile-questionnaires-interfaces';
import { SearchPageSwitchRequestedEvent, SearchType } from '@studyportals/search-page-interface';


export default class App implements ISubscriber<ProfileQuestionnairesCPIFilters>{
	constructor() {
		window.EventAggregationService?.subscribeTo(ProfileQuestionnairesCPIFilters.EventType, this, true);
	}

	public async notify(event: ProfileQuestionnairesCPIFilters):  Promise<void> {
		window.EventAggregationService?.publishTo(SearchPageSwitchRequestedEvent.EventType, new SearchPageSwitchRequestedEvent(SearchType.STUDY));

		for (const filter of event.filters) {
			await store.actions.processFilterSelection(filter as IFilterPayload);
		}
	}

	public isMastersPortal = computed((): boolean => {
		return store.getters.getPortalType() === PortalType.MASTER;
	});

	public isApplicationStatusError = computed((): boolean => {
		return store.getters.getApplicationStatus() as ApplicationStatusOptions === ApplicationStatusOptions.ERROR;
	});

	public hasStaticContent = computed((): boolean => {
		const content = store.getters.getFaqStaticContent();

		return content !== null && content.staticContentText !== null && content.staticContentText !== "";
	});
}
